import React, {useState} from 'react'
import {useHistory} from 'react-router'
import {Lesson, LessonAnnex, newCourseAnnex} from '../../api/course'
import {Button, notification, Popover, Space, Table} from 'antd'
import {DownloadOutlined, DeleteOutlined} from '@ant-design/icons'
import {DownloadFileModal} from 'components/DownloadFile'
import API from 'api'
import {useSelector} from 'react-redux'
import {IState} from 'reducers'

interface Props {
  annexes: LessonAnnex[]
  course: Lesson
  total: number
  grade_id: number
  updateCourseAnnexList: () => void
}

export const CourseAnnexCom: React.FC<Props> = ({
  annexes,
  course,
  total,
  grade_id,
  updateCourseAnnexList,
}) => {
  const columns = [
    {
      title: '序号',
      dataIndex: 'key',
      key: 'key',
      width: 187,
      render: (text, record, index) => {
        if (index < 9) {
          text = '0' + (index + 1).toString()
        } else {
          text = (index + 1).toString()
        }
        return <div>{text}</div>
      },
    },
    {
      title: '名称',
      dataIndex: 'name',
      key: 'name',
      width: 395,
      render: (text, record: LessonAnnex) => (
        <Button type="link" onClick={() => preview(record)} className="annex-btn-link">
          {text}
        </Button>
      ),
    },
    {
      title: '创建人',
      dataIndex: ['author', 'nickname'],
      key: 'nickname',
      width: 160,
      render: (text, record) => {
        return record.author.nickname || record.author.name
      },
    },
    {
      title: '更新时间',
      dataIndex: 'updated_at',
      key: 'updated_at',
      width: 160,
      render: text => text.substring(0, text.indexOf('T')),
    },
    {
      title: '类型',
      dataIndex: 'suffix',
      key: 'suffix',
      render: text => <div style={{color: getAnnexSuffixColor(text)}}>{text}</div>,
      width: 160,
    },
    {
      title: '操作',
      key: 'action',
      width: 138,
      render: (text, record: LessonAnnex) => (
        <Space size="middle">
          {user.username !== record.author.username ? (
            <Popover content={<div style={{padding: 12}}>当前用户没有权限删除</div>}>
              <Button
                type="text"
                icon={<DeleteOutlined />}
                className="delete-annex-button"
                disabled={true}
              />
            </Popover>
          ) : (
            <Button
              type="text"
              icon={<DeleteOutlined />}
              className="delete-annex-button"
              onClick={() => deleteAnnex(record)}
            />
          )}

          {getUserType() === 'guest' ? (
            <Popover content={<div style={{padding: 12}}>当前用户没有权限下载</div>}>
              <Button type="text" icon={<DownloadOutlined />} className="download-annex-button" />
            </Popover>
          ) : (
            <Button
              type="text"
              icon={<DownloadOutlined />}
              className="download-annex-button"
              onClick={() => {
                setCurrentAnnex(record)
                setDownloading(true)
              }}
            />
          )}
        </Space>
      ),
    },
  ]
  const history = useHistory()
  const [downloading, setDownloading] = useState(false)
  const user = useSelector((state: IState) => state.user)

  const [currentAnnex, setCurrentAnnex] = useState<LessonAnnex>(newCourseAnnex())

  const getUserType = () => {
    return user.type
  }

  // TODO: 依据不同文件类型展示不同的预览
  const preview = (annex: LessonAnnex) => {
    if (annex.suffix === 'sb3') {
      notification['info']({
        message: '通知',
        description: '程序文件不可预览',
        duration: 3,
      })
      return
    }
    console.log(annex)

    console.log(annex.lesson_annex_id)

    history.push({
      pathname: '/preview/' + annex.lesson_annex_id,
      state: {annex: annex, course: course, total: total, grade_id: grade_id},
    })
  }

  const deleteAnnex = (previewFile: LessonAnnex) => {
    API.delCourseAnnex(previewFile.lesson_annex_id).then(() => {
      updateCourseAnnexList()
    })
  }

  const getAnnexSuffixColor = (suffix: string) => {
    switch (suffix) {
      case 'doc':
      case 'docx':
      case 'pdf':
        return '#56CCF2'
      case 'ppt':
      case 'pptx':
        return '#EB5757'
      case 'mp4':
        return '#219653'
      case 'sb3':
        return '#AB49DA'
      default:
        return ''
    }
  }

  return (
    <>
      <Table
        columns={columns}
        dataSource={annexes}
        pagination={false}
        className="annexes-list-table"
      />
      <DownloadFileModal
        name={currentAnnex!.name}
        suffix={currentAnnex!.suffix}
        url={currentAnnex!.url}
        downloading={downloading}
        setDownloading={setDownloading}
      />
    </>
  )
}
